import React, { useState } from 'react';

function App() {
  const [activeTab, setActiveTab] = useState('overview');
  const [latency, setLatency] = useState(24);
  const [isPinging, setIsPinging] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState('');
  const [lastCheck, setLastCheck] = useState(new Date().toLocaleTimeString());

  const handlePing = () => {
    setIsPinging(true);
    setTimeout(() => {
      const simulatedLatency = Math.floor(Math.random() * (35 - 16 + 1)) + 16;
      setLatency(simulatedLatency);
      setLastCheck(new Date().toLocaleTimeString());
      setIsPinging(false);
    }, 600);
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setCopyFeedback(label);
    setTimeout(() => setCopyFeedback(''), 2500);
  };

  return (
    <div className="app-wrapper">
      {/* HEADER INSTITUCIONAL */}
      <header className="navbar-xolo">
        <div className="container py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <div className="xolo-logo-badge">
                <i className="bi bi-shield-fill text-danger fs-4"></i>
              </div>
              <div>
                <h1 className="brand-title">XOLO FEST 2026</h1>
                <p className="brand-subtitle">Club Tijuana Xoloitzcuintles • Estadio Caliente</p>
              </div>
            </div>

            <div className="d-none d-md-flex align-items-center gap-3">
              <div className="d-flex align-items-center gap-2 bg-dark px-3 py-1 rounded-pill border border-secondary border-opacity-25">
                <span className="status-dot"></span>
                <span className="small text-light fw-semibold">FASE 1: DEMO WEB ACTIVA</span>
              </div>
              <a
                href="#telemetria"
                className="btn btn-sm btn-outline-danger fw-semibold px-3"
              >
                <i className="bi bi-hdd-network me-1"></i> Telemetría VPS
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* HERO BANNER */}
      <section className="hero-section text-center">
        <div className="container">
          <div className="hero-pill">
            <i className="bi bi-fire text-warning"></i>
            Edición Oficial 2026 • 24 & 25 de Octubre
          </div>

          <h2 className="hero-title">
            El Festival de la Jauría
            <span className="hero-title-highlight">En el Estadio Caliente</span>
          </h2>

          <p className="hero-lead">
            Bienvenido a la plataforma digital oficial de <strong>Xolo Fest 2026</strong>. Música de clase mundial,
            gastronomía bajacaliforniana, convivencia con el plantel de los Xoloitzcuintles y
            un ecosistema tecnológico de vanguardia 100% cashless y móvil.
          </p>

          {/* ESTADO DE LA PLATAFORMA DIGITAL */}
          <div className="status-banner mb-5">
            <div className="status-indicator text-start">
              <span className="status-dot"></span>
              <div>
                <div className="fw-bold text-light">Infraestructura Digital en Línea</div>
                <small className="text-secondary">
                  Nodo Web en Nginx Alpine verificado en red de producción
                </small>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2">
              <span className="badge bg-success bg-opacity-25 text-success border border-success px-3 py-2">
                <i className="bi bi-check-circle-fill me-1"></i> SSL Let's Encrypt OK
              </span>
              <span className="badge bg-dark border border-secondary text-light px-3 py-2">
                <i className="bi bi-globe me-1 text-warning"></i> xolofest.mx
              </span>
            </div>
          </div>

          {/* KEY METRICS */}
          <div className="row g-3 justify-content-center text-start mb-4">
            <div className="col-6 col-md-3">
              <div className="stat-box">
                <div className="stat-number text-danger">25,000+</div>
                <div className="stat-label">Asistentes Proyectados</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="stat-box">
                <div className="stat-number text-warning">100%</div>
                <div className="stat-label">Experiencia Cashless</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="stat-box">
                <div className="stat-number text-light">4</div>
                <div className="stat-label">Escenarios y Zonas VIP</div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="stat-box">
                <div className="stat-number text-success">&lt;200ms</div>
                <div className="stat-label">Validación de Accesos</div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a href="#modulos" className="btn-xolo-primary text-decoration-none">
              <i className="bi bi-grid-3x3-gap-fill"></i> Explorar Módulos Fase 2
            </a>
            <a href="#telemetria" className="btn-xolo-outline text-decoration-none">
              <i className="bi bi-speedometer2"></i> Ver Telemetría en Vivo
            </a>
          </div>
        </div>
      </section>

      {/* PANEL DE TELEMETRÍA DE INFRAESTRUCTURA */}
      <section id="telemetria" className="py-5">
        <div className="container">
          <div className="telemetry-card">
            <div className="telemetry-header">
              <div className="d-flex align-items-center gap-2">
                <i className="bi bi-cpu-fill text-danger fs-5"></i>
                <h3 className="h5 mb-0 text-white fw-bold">Panel de Telemetría de Infraestructura Cloud</h3>
              </div>
              <div className="d-flex align-items-center gap-3">
                <span className="telemetry-badge">
                  <i className="bi bi-check2-circle"></i> Despliegue de Prueba Activo y Verificado 🟢
                </span>
                <button
                  onClick={handlePing}
                  disabled={isPinging}
                  className="btn btn-sm btn-outline-light d-flex align-items-center gap-1"
                  title="Ejecutar prueba de latencia"
                >
                  <i className={`bi bi-arrow-clockwise ${isPinging ? 'spinner-border spinner-border-sm' : ''}`}></i>
                  {isPinging ? 'Midiendo...' : 'Test Latencia'}
                </button>
              </div>
            </div>

            <div className="p-4">
              {copyFeedback && (
                <div className="alert alert-success py-2 px-3 small mb-3 border-0 bg-success bg-opacity-25 text-success">
                  <i className="bi bi-clipboard-check me-2"></i> {copyFeedback}
                </div>
              )}

              <div className="row g-3">
                {/* DOMINIO OFICIAL */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="telemetry-item">
                    <div>
                      <div className="telemetry-label">
                        <i className="bi bi-globe2 text-warning"></i> Dominio Oficial
                      </div>
                      <div className="telemetry-value text-danger">xolofest.mx</div>
                      <small className="text-secondary d-block mt-1">
                        Aliases: www.xolofest.mx | api.xolofest.mx
                      </small>
                    </div>
                    <div className="mt-3 pt-2 border-top border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                      <span className="badge bg-secondary bg-opacity-25 text-light font-monospace">DNS Type A</span>
                      <button
                        onClick={() => copyToClipboard('https://xolofest.mx', 'Dominio https://xolofest.mx copiado')}
                        className="btn btn-sm btn-link text-warning p-0 text-decoration-none"
                      >
                        <i className="bi bi-copy"></i> Copiar
                      </button>
                    </div>
                  </div>
                </div>

                {/* SERVIDOR VPS */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="telemetry-item">
                    <div>
                      <div className="telemetry-label">
                        <i className="bi bi-server text-info"></i> Servidor VPS
                      </div>
                      <div className="telemetry-value">64.202.184.242</div>
                      <small className="text-secondary d-block mt-1">
                        Ruta Host: <code>/opt/apps/xolofest</code>
                      </small>
                    </div>
                    <div className="mt-3 pt-2 border-top border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                      <span className="badge bg-secondary bg-opacity-25 text-info font-monospace">SSH :22</span>
                      <button
                        onClick={() => copyToClipboard('/opt/apps/xolofest', 'Ruta VPS copiada al portapapeles')}
                        className="btn btn-sm btn-link text-info p-0 text-decoration-none"
                      >
                        <i className="bi bi-copy"></i> Copiar Ruta
                      </button>
                    </div>
                  </div>
                </div>

                {/* CONTENEDOR ACTIVO */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="telemetry-item">
                    <div>
                      <div className="telemetry-label">
                        <i className="bi bi-box-seam text-danger"></i> Contenedor Activo
                      </div>
                      <div className="telemetry-value text-white">xolofest_web</div>
                      <small className="text-secondary d-block mt-1">
                        Imagen: <code>nginx:alpine</code> (Puerto 80 Interno)
                      </small>
                    </div>
                    <div className="mt-3 pt-2 border-top border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                      <span className="badge bg-danger bg-opacity-25 text-danger font-monospace">Up & Running</span>
                      <span className="small text-muted">React SPA Build</span>
                    </div>
                  </div>
                </div>

                {/* PROXY REVERSO */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="telemetry-item">
                    <div>
                      <div className="telemetry-label">
                        <i className="bi bi-shield-check text-success"></i> Proxy Reverso & SSL
                      </div>
                      <div className="telemetry-value text-success">NPM + Let's Encrypt</div>
                      <small className="text-secondary d-block mt-1">
                        Red Docker: <code>interaktia_proxy_net</code>
                      </small>
                    </div>
                    <div className="mt-3 pt-2 border-top border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                      <span className="badge bg-success bg-opacity-25 text-success">Force SSL / HSTS</span>
                      <span className="small text-muted">TLS 1.3</span>
                    </div>
                  </div>
                </div>

                {/* LATENCIA Y ESTADO */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="telemetry-item">
                    <div>
                      <div className="telemetry-label">
                        <i className="bi bi-activity text-warning"></i> Métricas de Salud
                      </div>
                      <div className="telemetry-value text-warning">
                        {latency} ms <small className="text-muted fs-6 fw-normal">Latencia Nginx</small>
                      </div>
                      <small className="text-secondary d-block mt-1">
                        Última comprobación: {lastCheck}
                      </small>
                    </div>
                    <div className="mt-3 pt-2 border-top border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                      <span className="badge bg-warning bg-opacity-25 text-warning">HTTP 200 OK</span>
                      <span className="small text-success">99.98% Uptime</span>
                    </div>
                  </div>
                </div>

                {/* STATUS GENERAL */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="telemetry-item">
                    <div>
                      <div className="telemetry-label">
                        <i className="bi bi-patch-check-fill text-success"></i> Estado General
                      </div>
                      <div className="telemetry-value text-success">
                        Despliegue de Prueba Activo y Verificado 🟢
                      </div>
                      <small className="text-secondary d-block mt-1">
                        Listo para orquestación de Fase 2
                      </small>
                    </div>
                    <div className="mt-3 pt-2 border-top border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
                      <span className="badge bg-success bg-opacity-25 text-success">Certificado Válido</span>
                      <span className="small text-muted">Five Digital Minds</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MÓDULOS DE INTEGRACIÓN (FASE 2) */}
      <section id="modulos" className="py-5 bg-black bg-opacity-40">
        <div className="container">
          <div className="text-center mb-4">
            <span className="hero-pill mb-2">Roadmap & Módulos</span>
            <h3 className="h2 text-white fw-bold">Ecosistema Tecnológico de Fase 2</h3>
            <p className="text-secondary max-w-600 mx-auto">
              Componentes del backend .NET 8, PostgreSQL y aplicaciones de campo que se integrarán
              tras la certificación de la infraestructura web.
            </p>
          </div>

          <div className="d-flex justify-content-center gap-2 mb-5 flex-wrap">
            <button
              onClick={() => setActiveTab('overview')}
              className={`btn btn-sm px-3 rounded-pill fw-semibold ${activeTab === 'overview' ? 'btn-danger' : 'btn-outline-secondary text-light'}`}
            >
              Todos los Módulos
            </button>
            <button
              onClick={() => setActiveTab('passport')}
              className={`btn btn-sm px-3 rounded-pill fw-semibold ${activeTab === 'passport' ? 'btn-danger' : 'btn-outline-secondary text-light'}`}
            >
              <i className="bi bi-qr-code-scan me-1"></i> Pasaporte Digital
            </button>
            <button
              onClick={() => setActiveTab('scanner')}
              className={`btn btn-sm px-3 rounded-pill fw-semibold ${activeTab === 'scanner' ? 'btn-danger' : 'btn-outline-secondary text-light'}`}
            >
              <i className="bi bi-upc-scan me-1"></i> Scanner Staff & POS
            </button>
            <button
              onClick={() => setActiveTab('command')}
              className={`btn btn-sm px-3 rounded-pill fw-semibold ${activeTab === 'command' ? 'btn-danger' : 'btn-outline-secondary text-light'}`}
            >
              <i className="bi bi-graph-up-arrow me-1"></i> Centro de Mando
            </button>
          </div>

          <div className="row g-4">
            {/* 1. PASAPORTE DIGITAL */}
            {(activeTab === 'overview' || activeTab === 'passport') && (
              <div className={`col-12 ${activeTab === 'passport' ? 'col-lg-8 mx-auto' : 'col-lg-4'}`}>
                <div className="module-card">
                  <div className="module-icon-wrap">
                    <i className="bi bi-qr-code-scan"></i>
                  </div>
                  <div className="module-tag">Módulo Fan & Accesos</div>
                  <h4 className="module-title">Pasaporte Digital</h4>
                  <p className="module-description">
                    Credencial web y móvil interactiva con tecnología QR dinámico offline-first.
                    Permite a cada aficionado gestionar boletos, consultar su saldo monedero y redimir accesos VIP.
                  </p>
                  <ul className="module-features-list">
                    <li><i className="bi bi-check-circle-fill"></i> Validación criptográfica sin fraude</li>
                    <li><i className="bi bi-check-circle-fill"></i> Recarga y consulta de saldo cashless</li>
                    <li><i className="bi bi-check-circle-fill"></i> Sincronización instantánea con backend</li>
                  </ul>
                </div>
              </div>
            )}

            {/* 2. SCANNER DE STAFF */}
            {(activeTab === 'overview' || activeTab === 'scanner') && (
              <div className={`col-12 ${activeTab === 'scanner' ? 'col-lg-8 mx-auto' : 'col-lg-4'}`}>
                <div className="module-card">
                  <div className="module-icon-wrap">
                    <i className="bi bi-upc-scan"></i>
                  </div>
                  <div className="module-tag">Operaciones de Campo</div>
                  <h4 className="module-title">Scanner Staff & POS</h4>
                  <p className="module-description">
                    Herramienta ultrarrápida para operadores en torniquetes, puertas perimetrales y barras de consumo.
                    Lectura ultra-eficiente de códigos QR y chips NFC con modo offline tolerante a fallas.
                  </p>
                  <ul className="module-features-list">
                    <li><i className="bi bi-check-circle-fill"></i> Lectura instantánea en &lt; 200 ms</li>
                    <li><i className="bi bi-check-circle-fill"></i> Soporte de cobro en barra y concesiones</li>
                    <li><i className="bi bi-check-circle-fill"></i> Bloqueo de duplicados en tiempo real</li>
                  </ul>
                </div>
              </div>
            )}

            {/* 3. CENTRO DE MANDO LIVE BOARD */}
            {(activeTab === 'overview' || activeTab === 'command') && (
              <div className={`col-12 ${activeTab === 'command' ? 'col-lg-8 mx-auto' : 'col-lg-4'}`}>
                <div className="module-card">
                  <div className="module-icon-wrap">
                    <i className="bi bi-graph-up-arrow"></i>
                  </div>
                  <div className="module-tag">Supervisión Ejecutiva</div>
                  <h4 className="module-title">Centro de Mando Live Board</h4>
                  <p className="module-description">
                    Tablero de telemetría y control para directivos de Xolos y coordinadores del festival.
                    Visualización de aforo en vivo por zona, velocidad de ventas y semáforos de seguridad.
                  </p>
                  <ul className="module-features-list">
                    <li><i className="bi bi-check-circle-fill"></i> Telemetría de flujo y aforo por puertas</li>
                    <li><i className="bi bi-check-circle-fill"></i> Métricas financieras y de consumo en vivo</li>
                    <li><i className="bi bi-check-circle-fill"></i> Alertas preventivas para brigadas</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ARQUITECTURA DE DESPLIEGUE */}
      <section className="py-5 border-top border-secondary border-opacity-10">
        <div className="container">
          <div className="arch-card">
            <div className="row align-items-center g-4">
              <div className="col-lg-6">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <span className="arch-step-badge">ARQUITECTURA CLOUD</span>
                  <span className="text-secondary small">Topología de Servicios</span>
                </div>
                <h3 className="h4 text-white fw-bold mb-3">Orquestación Dockerizada Segura</h3>
                <p className="text-secondary mb-3">
                  La Web Demo opera de forma aislada en el contenedor <code>xolofest_web</code> montado
                  sobre el proxy central Nginx Proxy Manager, garantizando renovación SSL automática y
                  enrutamiento sin fricciones para la próxima llegada de <code>xolofest_api</code> (.NET 8) y <code>xolofest_db</code> (PostgreSQL 16 en puerto 5437).
                </p>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge bg-dark border border-secondary text-secondary">Nginx Alpine</span>
                  <span className="badge bg-dark border border-secondary text-secondary">React 18 / 19</span>
                  <span className="badge bg-dark border border-secondary text-secondary">NPM Reverse Proxy</span>
                  <span className="badge bg-dark border border-secondary text-secondary">Let's Encrypt SSL</span>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="bg-black p-3 rounded-3 border border-secondary border-opacity-25 font-monospace small">
                  <div className="text-success mb-2"># Estado de Despliegue en VPS (64.202.184.242)</div>
                  <div className="text-light">$ docker compose ps</div>
                  <div className="text-secondary">NAME                IMAGE          STATUS          PORTS</div>
                  <div className="text-light">xolofest_web        nginx:alpine   Up (healthy)    80/tcp</div>
                  <div className="text-warning mt-2"># Red Proxy Compartida</div>
                  <div className="text-secondary">interaktia_proxy_net --&gt; xolofest.mx:443 (Let's Encrypt SSL)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER INSTITUCIONAL */}
      <footer className="footer-xolo">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-md-6 text-center text-md-start">
              <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-2 mb-2">
                <div className="xolo-logo-badge" style={{ width: '32px', height: '32px' }}>
                  <i className="bi bi-shield-fill text-danger fs-6"></i>
                </div>
                <span className="fw-bold text-white tracking-wide">XOLO FEST 2026</span>
                <span className="footer-badge">Oficial</span>
              </div>
              <p className="footer-copy mb-0">
                © 2026 Club Tijuana Xoloitzcuintles de Caliente. Todos los derechos reservados.
                <br />
                Estadio Caliente, Tijuana, Baja California, México.
              </p>
            </div>

            <div className="col-12 col-md-6 text-center text-md-end">
              <div className="small text-secondary mb-1">
                Desarrollo y Arquitectura de Infraestructura por:
              </div>
              <div className="fw-bold text-light">
                <i className="bi bi-lightning-charge-fill text-warning me-1"></i>
                Five Digital Minds
              </div>
              <div className="text-dim small mt-1">
                Innovación & Transformación Tecnológica
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
